export interface QuestionnaireSubmitResInterface {
  id: number
  schoolId: number
  rid: number
  questionnaireId: number
  activityTaskId: number
  reflectionDomain: string
  value: object
  otherValue?: object[]
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
}

export class QuestionnaireSubmitRes implements QuestionnaireSubmitResInterface {
  id: number
  schoolId: number
  rid: number
  questionnaireId: number
  activityTaskId: number
  reflectionDomain: string
  value: object
  otherValue?: object[]
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string

  constructor(props: QuestionnaireSubmitResInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      id: _id,
      schoolId: _schoolId,
      rid: _rid,
      questionnaireId: _questionnaireId,
      activityTaskId: _activityTaskId,
      reflectionDomain: _reflectionDomain,
      value: _value,
      otherValue: _otherValue,
      createdAt: _createdAt,
      updatedAt: _updatedAt,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.id = _id
    this.schoolId = _schoolId
    this.rid = _rid
    this.questionnaireId = _questionnaireId
    this.activityTaskId = _activityTaskId
    this.reflectionDomain = _reflectionDomain
    this.value = _value
    this.otherValue = _otherValue
    this.createdAt = _createdAt
    this.updatedAt = _updatedAt
  }
}
